export default __webpack_public_path__ + "static/media/expiredQr.55dd2e0f.png";